export class CancelDTO
{
    constructor()
        {
            this.English = "Cancel";
            this.Arabic = "الغاء";
        }
    English:string 
    Arabic:string 
}